export function moveBackTwoIndices(arr, key) {
  const index = arr.indexOf(key);
  if (index !== -1) {
    const [item] = arr.splice(index, 1);
    const newIndex = Math.max(index + 2, 0);
    arr.splice(newIndex, 0, item);
  }
  return arr;
}
